module.exports = __webpack_public_path__ + "static/scientist10-7fe66c2aa45bccc15db4b1f4aab536db.jpg";